module.exports = __webpack_public_path__ + "img/footer.87a6e8ca.webp";